import React from 'react';
import Helmet from 'react-helmet';
import { setParam } from '../../utils/helper';
import { langCodeAllowed } from '../../locales';
const CategoryHelmet = props => {
  const {
    location,
    categoryData,
    LISTING_PAGE_SIZE,
    pathname,
    currUrl,
    pageParam,
    localeInfo = {},
  } = props;
  const {
    product_list,
    breadcrumb,
    num_of_products,
    seo_title,
    category_name,
    seo_meta_description,
    seo_meta_keywords,
  } = categoryData;
  const { domainUrl, domain } = localeInfo;
  const listSchema =
    (product_list &&
      product_list.map((item, index) => {
        return {
          '@type': 'ListItem',
          position: index + 1,
          url: item.product_url,
          name: `${item.brand_name} ${item.model_name}`,
          image: item.image_url,
        };
      })) ||
    [];
  const bCrumbSchema =
    (breadcrumb &&
      breadcrumb.map((item, index) => {
        return (
          item.link && {
            '@type': 'ListItem',
            position: index + 1,
            item: {
              '@id': `${domain}/${String(item.link)
                .replace(`${domainUrl}`, '')
                .replace('mobile/', '')}`,
              name: item.label,
            },
          }
        );
      })) ||
    [];
  let hrefLink =
    pageParam >= 1 && (pageParam + 1) * LISTING_PAGE_SIZE < num_of_products
      ? setParam(`${localeInfo.domain}${pathname}`, 'page', pageParam + 1)
      : `${localeInfo.domain}${pathname}`;
  hrefLink = location.search ? `${localeInfo.domain}${pathname}${location.search}` : hrefLink;
  const keysArray = Object.keys(langCodeAllowed);
  const linkArray = [
    {
      rel: 'next',
      id: 'next-page',
      href:
        pageParam >= 0 && (pageParam + 1) * LISTING_PAGE_SIZE < num_of_products
          ? setParam(currUrl, 'page', pageParam + 1)
          : `${domain}${pathname}`,
    },
    {
      rel: 'prev',
      id: 'prev-page',
      href:
        pageParam > 1 && (pageParam - 1) * LISTING_PAGE_SIZE < num_of_products
          ? setParam(currUrl, 'page', pageParam - 1)
          : `${domain}${pathname}`,
    },
    { rel: 'alternate', href: `${domain}${pathname}` },
    { rel: 'canonical', href: `${domain}${pathname}` },
  ];
  keysArray.forEach(keys =>
    linkArray.push({
      rel: 'alternate',
      hrefLang: `${langCodeAllowed[keys]?.hrefLang}`,
      href: hrefLink,
    })
  );
  let metaArray = [
    {
      name: 'description',
      content: seo_meta_description || `Buy ${category_name} Online at Low Prices in India`,
    },
    { name: 'keywords', content: seo_meta_keywords },
    { name: 'robots', content: 'INDEX,FOLLOW' },
    { property: 'og:site_name', content: 'Lenskart.com' },
    { property: 'og:title', content: seo_title },
    { property: 'og:description', content: seo_meta_description },
    { property: 'og:url', content: `${domain}${pathname}` },
    { property: 'og:type', content: 'lenskartwebsite:product' },
    { name: 'twitter:title', content: seo_title },
    { name: 'twitter:description', content: seo_meta_description },
  ];
  if (localeInfo.countryCode === 'sg') {
    metaArray = metaArray.filter(item => item.name !== 'robots');
  }
  return (
    <Helmet
      link={linkArray}
      meta={metaArray}
      script={[
        ...(listSchema.length
          ? [
              {
                type: 'application/ld+json',
                innerHTML: JSON.stringify({
                  '@context': 'https://schema.org',
                  '@type': 'ItemList',
                  itemListElement: listSchema,
                }),
              },
            ]
          : []),
        ...(bCrumbSchema.length
          ? [
              {
                type: 'application/ld+json',
                innerHTML: JSON.stringify({
                  '@context': 'https://schema.org',
                  '@type': 'BreadcrumbList',
                  itemListElement: bCrumbSchema,
                }),
              },
            ]
          : []),
      ]}
      title={
        (seo_title ||
          `Buy ${category_name} Online | Shop for ${category_name} at Low Price - Lenskart.com`) +
        (pageParam > 0 ? ` ,page ${pageParam}` : '')
      }
    ></Helmet>
  );
};

export default CategoryHelmet;
